import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { HorizontalSafeAreaContainer } from '../HorizontalSafeAreaContainer';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Native header background that continues the `HorizontalSafeAreaContainer`
 * side borders into the header, for screens whose content uses that container.
 */
export const HorizontalSafeAreaHeaderBackground = () => {
  return (
    <HorizontalSafeAreaContainer>
      <View style={styles.background} />
    </HorizontalSafeAreaContainer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  background: {
    flex: 1,
    backgroundColor: theme.colors.APP_BACKGROUND,
  },
});
